import React from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css"; // 默认样式
import "./index.css";

// 导入头像资源
import avatar1 from "../../assets/images/avatars/1.png";
import avatar2 from "../../assets/images/avatars/2.png";
import avatar3 from "../../assets/images/avatars/3.png";
import avatar4 from "../../assets/images/avatars/4.png";
import avatar5 from "../../assets/images/avatars/5.png";
import avatar6 from "../../assets/images/avatars/6.png";
import avatar7 from "../../assets/images/avatars/7.png";
import avatar8 from "../../assets/images/avatars/8.png";
import avatar9 from "../../assets/images/avatars/9.png";
import avatar10 from "../../assets/images/avatars/10.png";
import avatar11 from "../../assets/images/avatars/11.png";

export default function AvatarSlider() {
  const avatars = [
    avatar1,
    avatar2,
    avatar3,
    avatar4,
    avatar5,
    avatar6,
    avatar7,
    avatar8,
    avatar9,
    avatar10,
    avatar11,
  ];

  return (
    <Splide
      className=""
      options={{
        type: "loop", // 无限循环
        perPage: 6,
        perMove: 1,
        focus: "center", // 中心对齐
        gap: 18, // 间距
        autoplay: true, // 自动播放
        interval: 1500, // 播放间隔
        pauseOnHover: false, // 鼠标悬停时暂停
        pagination: false, // 不显示分页器
        arrows: false, // 不显示箭头
        updateOnMove: true, // 滑动时实时更新状态
        height: "388px", // 整个滑块高度
        width: "100%",
        // width: "100%",
        // slideFocus: true,
        autoWidth: true,
        // autoHeight: true,
      }}
      aria-label="Avatar Slider"
    >
      {avatars.map((avatar, index) => (
        <SplideSlide key={index} className="avatar-slide">
          <img
            className="avatar-item"
            src={avatar}
            alt={`Avatar ${index + 1}`}
          />
        </SplideSlide>
      ))}
    </Splide>
  );
}
